import { AmsAccountMatchReason } from '@oysterjs/ais/api/graphql';

/**
 * How each match reason reads. Shared by AMS reconciliation and a client's
 * account suggestions, because the schema gives one reason one meaning: a
 * label that said "Name + email match" in one place and something else in the
 * other would describe the same evidence two ways.
 */
export const MATCH_REASON_LABEL: Record<AmsAccountMatchReason, string> = {
  [AmsAccountMatchReason.ClientLink]: "Client's AMS account",
  [AmsAccountMatchReason.ClientLinkNameOnly]: 'Client matched by name',
  [AmsAccountMatchReason.LookupCode]: 'Lookup code match',
  [AmsAccountMatchReason.PolicyNumber]: 'Policy number match',
  [AmsAccountMatchReason.NameAndEmail]: 'Name + email match',
  [AmsAccountMatchReason.Email]: 'Email match',
  [AmsAccountMatchReason.Phone]: 'Phone match',
  [AmsAccountMatchReason.SimilarName]: 'Similar name'
};
